import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import Preloader from "../Preloader/preloader";
import SimpleContext from "./../context/SimpleContext";
import plus from "../img/plus.png";
import plus2 from "../img/plus2.png";
import mini from "../img/mini.png";
import useLocalStorageState from "use-local-storage-state";

const BuyBtn = ({ Product }) => {
  const [firstAdd, setfirstAdd] = useState(false);
  const [min, setmin] = useState(false);
  const [call, setcall] = useState(false);
  const [counter, setcounter] = useState(1);
  const [forceUpdate, setforceUpdate] = useState(0);
  const [add, setadd] = useState(false);
  const context = useContext(SimpleContext);

  if(Object.values(Product).length>0){
    if (Product.temp === undefined) {
      Product.temp = 0;
    }
  }

  //این تابع چک میکند که اگر آبجکت پروداکت پریلودر نداشته باشد ان را ست میکند
  if (Product.showPreloader === undefined) {
    context.searchProducts.productLists.forEach((object) => {
      object.showPreloader = false;
    });
  }

  useEffect(() => {
    setadd(true);
    if (add === true) {
      const timer =
        counter > 0 && setInterval(() => setcounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, add]);

  useEffect(() => {
    if (add === true && counter === 0) {
      context.handleAddToCard(
        1,
        Product.price,
        Product.productRef,
        Product.temp,
        Product.unitName,
        Product.showPreloader,
        Product.banner
      );
    }
  }, [counter]);


  useEffect(() => {
    setadd(false);
  },[Product.basketSelection]);

  useEffect(() => {
    Product.temp=0
  },[context.resAdd]);

  //تابع برای زمانی که کاربر اولین بار یک محوصل را به سبد خرید اضافه میکند
  function AddOne(
    minimum,
    price,
    productRef,
    basketSelection,
    unitName,
    showPreloader
  ) {
    setfirstAdd(true);
    showPreloader = true;
    if (minimum > 0) {
      setmin(true);
      Product.temp = Product.temp + 1;
      Product.basketSelection =
      parseInt(Product.basketSelection) + parseInt(Product.increaseStep);
      setforceUpdate(!forceUpdate);
      setadd(true);
      setcounter(1);
    } else if (minimum < 0) {
      Product.temp = Product.temp - 1;
      setmin(false);
      Product.basketSelection =
      parseInt(Product.basketSelection) - parseInt(Product.increaseStep);
      setforceUpdate(!forceUpdate);
      setadd(true);
      setcounter(1);
    }
  }
  //ست کردن اطلاعات محصول برای استفاده در انتخاب مقدار ادد تو کارت
  const showNum = (product) => {
    context.setshowmodalNum(true);
    context.setproductNum(product);
  };

  return (
    <>
      {Product.showPreloader === true ? (
        <button style={{ margin: "0" }} className="ButtonBtnBuy">
          <Preloader />
        </button>
      ) : parseInt(Product.stock) === 0 || parseInt(Product.stock) < 0 ? (
        <button
          onClick={() => context.Handelerror(Product.stockToast)}
          style={{ margin: "0" }}
          className="ButtonBtnNamojud"
        >
          {Product.stockDescription}
        </button>
      ) : parseInt(Product.basketSelection) === 0 ? (
        <button
          onClick={() =>
            AddOne(
              Product.minimum,
              Product.price,
              Product.productRef,
              Product.basketSelection,
              Product.unitName,
              Product.showPreloader
            )
          }
          style={{ margin: "0" }}
          className="ButtonBtnBuy"
        >
          <img style={{ width: "25px" }} src={plus2} />
        </button>
      ) : (
        <div className="badgeBuyBtnDis">
          <div>
            {parseInt(Product.basketSelection) === Product.stock ? (
              <div style={{ backgroundColor: "gray" }} className="iconeCatBtn">
                <img src={plus} style={{ width: "15px" }} />
              </div>
            ) : (
              <div
                className="iconeCatBtn"
                onClick={() =>
                  AddOne(
                    Product.minimum,
                    Product.price,
                    Product.productRef,
                    Product.basketSelection,
                    Product.unitName,
                    Product.showPreloader
                  )
                }
              >
                <img src={plus} style={{ width: "15px" }} />
              </div>
            )}
          </div>

          <div onClick={() => showNum(Product)}>
            {`${Product.basketSelection}`}
          </div>

          <div
            className="iconeCatBtn"
            onClick={() =>
              AddOne(
                -Product.minimum,
                Product.price,
                Product.productRef,
                Product.basketSelection,
                Product.unitName,
                Product.showPreloader
              )
            }
          >
            <img src={mini} style={{ width: "20px" }} />
          </div>
        </div>
      )}
    </>
  );
};

export default BuyBtn;
